import React from "react";

// EU AI Act Art. 50 copy, shared with the PDF report templates and the mobile app.
export const AI_DISCLAIMER_SHORT = "AI-generated cosmetic insights. Not medical advice.";
export const AI_TRY_ON_NOTE =
    "Hair, makeup and similar previews are created by generative AI. They are illustrative simulations and may differ from real results.";

interface AIDisclaimerFooterProps {
    /** The page shows AI-generated images (hair / makeup previews). */
    generatedPreviews?: boolean;
}

export default function AIDisclaimerFooter({ generatedPreviews = false }: AIDisclaimerFooterProps): React.JSX.Element {
    return (
        <div
            className="mt-6 pt-4 text-center"
            style={{ borderTop: '1px solid var(--rule)', color: 'var(--ink-muted)', fontSize: 'var(--fs-label)' }}
        >
            {generatedPreviews && <p style={{ marginBottom: 'var(--s-2)' }}>{AI_TRY_ON_NOTE}</p>}
            <p>
                {AI_DISCLAIMER_SHORT}{' '}•{' '}
                <a
                    href="/ai-disclaimer"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline underline-offset-2"
                    style={{ color: 'var(--c-kivo-teal)' }}
                >
                    Learn more
                </a>
                {' '}•{' '}
                <a
                    href="/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline underline-offset-2"
                    style={{ color: 'var(--c-kivo-teal)' }}
                >
                    Privacy
                </a>
                {' '}•{' '}
                <a
                    href="/refund"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline underline-offset-2"
                    style={{ color: 'var(--c-kivo-teal)' }}
                >
                    Refund
                </a>
            </p>
        </div>
    );
}
